export default "__VITE_ASSET__D$ZPwipP__";